export class AllocationViewRuleModel {
  id: string;
  name: string;
}
